// extracted by mini-css-extract-plugin
export default {"wrap":"Ks-z","fullWidth":"Ls-z","items":"Ms-z","featureCss":"Ns-z","disabled":"Os-z","imgCss":"Ps-z"};